import { Button } from "PFComponents/button";
import { LoadingDots } from "PFComponents/loading_dots";
import { useTranslation } from "react-i18next";

type MoreButtonProps = {
  page: number;
  perPage: number;
  renderedItemsCount: number;
  total: number;
  handleClick: () => void;
  isLoading?: boolean;
};

export const MoreButton = ({
  renderedItemsCount,
  total,
  handleClick,
  isLoading,
  perPage,
  page
}: MoreButtonProps) => {
  const { t } = useTranslation();
  // the meta.total returned from api might not match the actual total ammount of entities
  // returned by the api - hence the addtional checks
  const isAll = renderedItemsCount >= total;
  const isALastPageOrGreater = page >= Math.max(total, renderedItemsCount) / perPage;

  if (isAll || isALastPageOrGreater) {
    return null;
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", margin: 30 }}>
      {isLoading ? (
        <LoadingDots circlesEnabled circleSize="xs" />
      ) : (
        <Button
          key={renderedItemsCount /*avoid hover state on mobiles*/}
          kind="secondary"
          small
          onClick={handleClick}
          disabled={isLoading}
        >
          {t("more")}
        </Button>
      )}
    </div>
  );
};
